import { render } from "./Servicess.vue?vue&type=template&id=014edc36&scoped=true"
import script from "./Servicess.vue?vue&type=script&lang=js"
export * from "./Servicess.vue?vue&type=script&lang=js"

import "./Servicess.vue?vue&type=style&index=0&id=014edc36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-014edc36"

export default script